import { PHOTO_AUTHOR_LINK, PHOTO_AUTHOR_NAME, PHOTO_AUTHOR_PHOTOS_NUM } from "../constants"

class AuthorEntity {
  constructor({ name, url, photosNum }) {
    this.name = name
    this.url = url
    this.photosNum = photosNum
  }

  static FromJson(json) {
    return new AuthorEntity({
      name: json.author_name,
      url: json.user ? json.user.url : null,
      photosNum: json.user ? json.user.num_photos : null,
    })
  }

  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @memberof AuthorEntity
   */
  static fromHtmlElement(htmlElement) {
    const nameElement = htmlElement.querySelector(PHOTO_AUTHOR_NAME)
    const linkElement = htmlElement.querySelector(PHOTO_AUTHOR_LINK)
    const photosElement = htmlElement.querySelector(PHOTO_AUTHOR_PHOTOS_NUM)

    return new AuthorEntity({
      name: nameElement.textContent || null,
      url: linkElement ? linkElement.href : null,
      photosNum: photosElement ? Number(photosElement.textContent) : null,
    })
  }
}

export default AuthorEntity
